import React from 'react';
import { IoBugOutline, IoSearchCircle, IoBookOutline, IoListOutline } from "react-icons/io5";
import { GrTasks, GrDocumentWord } from "react-icons/gr";
import { PiDetective } from "react-icons/pi";
import { Tooltip } from '../ui/Tooltip';
import { getTaskTypeConfig } from '../../utils/taskUtils';
import './TaskTypeIcon.css';

const TaskTypeIcon = ({ taskType, size = 20, className = '' }) => {
  const config = getTaskTypeConfig(taskType);
  
  const getIcon = () => {
    switch (config.icon) {
      case 'story':
        return <IoBookOutline size={size} />;
      case 'subtask':
        return <IoListOutline size={size} />;
      case 'bug':
        return <IoBugOutline size={size} />;
      case 'research':
        return <IoSearchCircle size={size} />;
      case 'documentation':
        return <GrDocumentWord size={size} />;
      case 'analysis':
        return <PiDetective size={size} />;
      case 'task':
      default:
        return <GrTasks size={size === 20 ? 15 : size} />;
    }
  };

  return (
    <Tooltip content={taskType || 'Task'}>
      <div 
        className={`task-type-icon-wrapper ${className}`}
        style={{
          backgroundColor: config.bgColor,
          color: config.iconColor,
          borderColor: config.borderColor
        }}
      >
        {getIcon()}
      </div>
    </Tooltip>
  );
};

export default TaskTypeIcon;

